
import type { PEOProvider } from '@/types/peo.types';
import { LoadingState } from './list/LoadingState';
import { ErrorState } from './list/ErrorState';
import { EmptyState } from './list/EmptyState';
import { ProviderGrid } from './list/ProviderGrid';

interface PEOProvidersListProps {
  providers: PEOProvider[];
  isLoading: boolean;
  isError?: boolean;
  error?: any;
  onAddProvider: () => void;
  onEditProvider?: (provider: PEOProvider) => void; // Optional since we now use onManageOrganization as primary
  onManageOrganization: (provider: PEOProvider) => void; // Primary action for providers
  isDeletingProvider?: boolean;
  showDebugInfo?: boolean;
}

export const PEOProvidersList = ({
  providers,
  isLoading,
  isError,
  error,
  onAddProvider,
  onEditProvider,
  onManageOrganization,
  isDeletingProvider,
  showDebugInfo
}: PEOProvidersListProps) => {
  if (isLoading) {
    return <LoadingState />;
  }

  if (isError) {
    return <ErrorState onAddProvider={onAddProvider} />;
  }

  if (providers.length === 0) {
    return <EmptyState onAddProvider={onAddProvider} />;
  }

  return (
    <ProviderGrid 
      providers={providers} 
      onEditProvider={onEditProvider}
      onManageOrganization={onManageOrganization}
    />
  );
};
